import { render, staticRenderFns } from "./RedeemVoucherToCoupon.vue?vue&type=template&id=81cab7be&scoped=true"
import script from "./RedeemVoucherToCoupon.vue?vue&type=script&lang=ts"
export * from "./RedeemVoucherToCoupon.vue?vue&type=script&lang=ts"
import style0 from "./RedeemVoucherToCoupon.vue?vue&type=style&index=0&id=81cab7be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cab7be",
  null
  
)

export default component.exports